import { useMutation } from "@tanstack/react-query";
import { GeneralResponse } from "../../interface/GeneralResponse";
import Api from "../../api/generalApi/Api";
import { Method, Methods } from "../../Constants/ApiConstants";
const usePostData = (endpoint: string,method?:Method) => {
  const mutation = useMutation({
    mutationFn: (data: any): Promise<GeneralResponse> => {
      return Api<any, GeneralResponse>({
        method: method ?? Methods.POST,
        endpoint: endpoint, 
        body: data,
      });
    },
  });

  return mutation;
};

export default usePostData;
